import type { SupportedCurrencies } from 'types/currencies'

import classes from './styles.module.scss'

type Props = {
  activeCurrency: SupportedCurrencies
  isLoggedIn?: boolean
}

export default function Badge({ activeCurrency, isLoggedIn }: Props) {
  return (
    <div className={classes.badge}>
      {!isLoggedIn && <img src={`${process.env.IMG_ORIGIN}/game-description/badges/badge_pink.png`} alt='badge-img' />}
      {activeCurrency === 'SC' && isLoggedIn && (
        <img src={`${process.env.IMG_ORIGIN}/game-description/badges/badge_green.png`} alt='badge-img' />
      )}
      {activeCurrency === 'GC' && isLoggedIn && (
        <img src={`${process.env.IMG_ORIGIN}/game-description/badges/badge_orange.png`} alt='badge-img' />
      )}
      <span>Want more?</span>
    </div>
  )
}
